var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBubblesBluecolors(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 297 561",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M69.605 249.204c-8.489 0-15.37 6.882-15.37 15.37 0 8.489 6.881 15.371 15.37 15.371 8.489 0 15.37-6.882 15.37-15.371 0-8.488-6.881-15.37-15.37-15.37z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M35.883 263.549a.512.512 0 10-.001 1.024.512.512 0 000-1.024z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M69.605 308.522c-8.489 0-15.37 6.882-15.37 15.37 0 8.489 6.881 15.371 15.37 15.371 8.489 0 15.37-6.882 15.37-15.371 0-8.488-6.881-15.37-15.37-15.37z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M35.37 308.522c-8.488 0-15.37 6.882-15.37 15.37 0 8.489 6.882 15.371 15.37 15.371 8.49 0 15.37-6.882 15.37-15.371 0-8.488-6.88-15.37-15.37-15.37z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M52.483 279.093c-8.489 0-15.37 6.882-15.37 15.371 0 8.488 6.881 15.37 15.37 15.37 8.489 0 15.37-6.882 15.37-15.37 0-8.489-6.881-15.371-15.37-15.371z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M70.63 372.71a8.198 8.198 0 100 16.396 8.198 8.198 0 000-16.396z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M70.63 432.605a8.197 8.197 0 100 16.395 8.197 8.197 0 000-16.395z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M36.395 432.605a8.197 8.197 0 100 16.395 8.197 8.197 0 000-16.395z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M53.507 403.175a8.198 8.198 0 100 16.395 8.198 8.198 0 000-16.395z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M293.008 226.019a8.197 8.197 0 100 16.395 8.198 8.198 0 000-16.395z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M293.008 285.337a8.198 8.198 0 100 16.396 8.198 8.198 0 000-16.396z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M292.218 343.28a8.197 8.197 0 00-8.197 8.197 8.197 8.197 0 1016.395 0 8.198 8.198 0 00-8.198-8.197z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M292.218 403.173a8.197 8.197 0 00-8.197 8.198 8.198 8.198 0 108.197-8.198z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M241.045 194.335c-5.659 0-10.247 4.588-10.247 10.247s4.588 10.247 10.247 10.247 10.247-4.588 10.247-10.247-4.588-10.247-10.247-10.247z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M206.8 194.335c-5.659 0-10.247 4.588-10.247 10.247s4.588 10.247 10.247 10.247 10.247-4.588 10.247-10.247-4.588-10.247-10.247-10.247z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M172.565 194.335c-5.659 0-10.247 4.588-10.247 10.247s4.588 10.247 10.247 10.247 10.247-4.588 10.247-10.247-4.588-10.247-10.247-10.247z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M155.443 164.906c-5.659 0-10.247 4.588-10.247 10.247s4.588 10.247 10.247 10.247 10.247-4.588 10.247-10.247-4.588-10.247-10.247-10.247z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M275.895 255.447a8.197 8.197 0 100 16.395 8.197 8.197 0 008.197-8.198 8.197 8.197 0 00-8.197-8.197z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M241.045 253.399c-5.659 0-10.247 4.587-10.247 10.247 0 5.659 4.588 10.247 10.247 10.247s10.247-4.588 10.247-10.247c0-5.66-4.588-10.247-10.247-10.247z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M206.8 253.399c-5.659 0-10.247 4.587-10.247 10.247 0 5.659 4.588 10.247 10.247 10.247s10.247-4.588 10.247-10.247c0-5.66-4.588-10.247-10.247-10.247z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M172.391 249.204c-8.489 0-15.37 6.882-15.37 15.37 0 8.489 6.881 15.371 15.37 15.371 8.489 0 15.37-6.882 15.37-15.371 0-8.488-6.881-15.37-15.37-15.37z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M258.157 223.969c-5.659 0-10.246 4.588-10.246 10.247s4.587 10.247 10.246 10.247c5.66 0 10.247-4.588 10.247-10.247s-4.587-10.247-10.247-10.247z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M223.913 223.969c-5.659 0-10.247 4.588-10.247 10.247s4.588 10.247 10.247 10.247 10.247-4.588 10.247-10.247-4.588-10.247-10.247-10.247z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M189.678 223.969c-5.659 0-10.247 4.588-10.247 10.247s4.588 10.247 10.247 10.247 10.247-4.588 10.247-10.247-4.588-10.247-10.247-10.247z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M155.443 223.969c-5.659 0-10.247 4.588-10.247 10.247s4.588 10.247 10.247 10.247 10.247-4.588 10.247-10.247-4.588-10.247-10.247-10.247z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M275.28 312.717c-5.659 0-10.247 4.587-10.247 10.247 0 5.659 4.588 10.246 10.247 10.246s10.247-4.587 10.247-10.246c0-5.66-4.588-10.247-10.247-10.247z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M241.045 312.717c-5.659 0-10.247 4.587-10.247 10.247 0 5.659 4.588 10.246 10.247 10.246s10.247-4.587 10.247-10.246c0-5.66-4.588-10.247-10.247-10.247z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M207.651 313.648a8.198 8.198 0 100 16.396 8.198 8.198 0 000-16.396z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M172.391 308.522c-8.489 0-15.37 6.882-15.37 15.37 0 8.489 6.881 15.371 15.37 15.371 8.489 0 15.37-6.882 15.37-15.371 0-8.488-6.881-15.37-15.37-15.37z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M258.157 283.288c-5.659 0-10.246 4.587-10.246 10.246 0 5.66 4.587 10.247 10.246 10.247 5.66 0 10.247-4.587 10.247-10.247 0-5.659-4.587-10.246-10.247-10.246z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M223.913 283.288c-5.659 0-10.247 4.587-10.247 10.246 0 5.66 4.588 10.247 10.247 10.247s10.247-4.587 10.247-10.247c0-5.659-4.588-10.246-10.247-10.246z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M189.504 279.093c-8.489 0-15.371 6.882-15.371 15.371 0 8.488 6.882 15.37 15.371 15.37s15.37-6.882 15.37-15.37c0-8.489-6.881-15.371-15.37-15.371z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M155.269 279.093c-8.489 0-15.37 6.882-15.37 15.371 0 8.488 6.881 15.37 15.37 15.37 8.489 0 15.37-6.882 15.37-15.37 0-8.489-6.881-15.371-15.37-15.371z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M275.106 372.709a8.198 8.198 0 100 16.396 8.198 8.198 0 000-16.396z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M241.045 378.215a4.099 4.099 0 100 8.197 4.099 4.099 0 000-8.197z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M238.381 140.429a4.1 4.1 0 100 8.199 4.1 4.1 0 000-8.199z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M206.8 378.215a4.099 4.099 0 100 8.197 4.099 4.099 0 000-8.197z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M204.136 140.429a4.099 4.099 0 100 8.198 4.099 4.099 0 000-8.198z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M272.417 140.429a4.099 4.099 0 100 8.198 4.099 4.099 0 000-8.198z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M272.417 198.448a4.099 4.099 0 100 8.197 4.099 4.099 0 000-8.197z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M173.416 372.71a8.198 8.198 0 100 16.396 8.198 8.198 0 000-16.396z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M258.158 348.785a4.099 4.099 0 100 8.198 4.099 4.099 0 000-8.198z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M255.494 111a4.099 4.099 0 100 8.198 4.099 4.099 0 000-8.198z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M223.912 348.785a4.099 4.099 0 10.001 8.197 4.099 4.099 0 00-.001-8.197z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M221.248 111a4.099 4.099 0 10.001 8.197 4.099 4.099 0 00-.001-8.197z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M289.529 111a4.099 4.099 0 100 8.198 4.099 4.099 0 000-8.198z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M190.528 343.282a8.197 8.197 0 00-8.197 8.198 8.198 8.198 0 108.197-8.198z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M156.293 343.282a8.197 8.197 0 00-8.197 8.198 8.197 8.197 0 008.197 8.197 8.197 8.197 0 100-16.395z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M275.106 432.603a8.198 8.198 0 100 16.395 8.198 8.198 0 000-16.395z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M241.045 438.108a4.099 4.099 0 100 8.198 4.099 4.099 0 000-8.198z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M206.8 438.108a4.099 4.099 0 100 8.198 4.099 4.099 0 000-8.198z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M172.565 438.108a4.099 4.099 0 10.001 8.197 4.099 4.099 0 00-.001-8.197z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M257.983 403.173a8.197 8.197 0 00-8.197 8.198 8.197 8.197 0 008.197 8.197 8.197 8.197 0 100-16.395z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M223.912 408.678a4.1 4.1 0 10.002 8.198 4.1 4.1 0 00-.002-8.198z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M221.248 170.892a4.099 4.099 0 10.001 8.197 4.099 4.099 0 00-.001-8.197z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M289.529 170.892a4.099 4.099 0 100 8.198 4.099 4.099 0 000-8.198z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M189.678 408.678a4.1 4.1 0 100 8.199 4.1 4.1 0 000-8.199z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M187.014 170.892a4.099 4.099 0 100 8.198 4.099 4.099 0 000-8.198z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M255.294 170.892a4.099 4.099 0 10.001 8.197 4.099 4.099 0 00-.001-8.197z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M156.293 403.175a8.197 8.197 0 00-8.197 8.198 8.197 8.197 0 008.197 8.197 8.197 8.197 0 100-16.395z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M138.403 194.335c-5.66 0-10.247 4.588-10.247 10.247s4.587 10.247 10.247 10.247c5.659 0 10.246-4.588 10.246-10.247s-4.587-10.247-10.246-10.247z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M104.157 194.335c-5.659 0-10.246 4.588-10.246 10.247s4.587 10.247 10.246 10.247c5.66 0 10.247-4.588 10.247-10.247s-4.587-10.247-10.247-10.247z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M138.228 249.204c-8.489 0-15.37 6.882-15.37 15.37 0 8.489 6.881 15.371 15.37 15.371 8.489 0 15.37-6.882 15.37-15.371 0-8.488-6.881-15.37-15.37-15.37z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M103.983 249.204c-8.489 0-15.37 6.882-15.37 15.37 0 8.489 6.881 15.371 15.37 15.371 8.489 0 15.371-6.882 15.371-15.371 0-8.488-6.882-15.37-15.371-15.37z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M121.096 219.775c-8.489 0-15.371 6.882-15.371 15.37 0 8.489 6.882 15.371 15.371 15.371 8.488 0 15.37-6.882 15.37-15.371 0-8.488-6.882-15.37-15.37-15.37z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M86.86 219.775c-8.488 0-15.37 6.882-15.37 15.37 0 8.489 6.882 15.371 15.37 15.371 8.49 0 15.371-6.882 15.371-15.371 0-8.488-6.881-15.37-15.37-15.37z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M138.228 308.522c-8.489 0-15.37 6.882-15.37 15.37 0 8.489 6.881 15.371 15.37 15.371 8.489 0 15.37-6.882 15.37-15.371 0-8.488-6.881-15.37-15.37-15.37z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M103.983 308.522c-8.489 0-15.37 6.882-15.37 15.37 0 8.489 6.881 15.371 15.37 15.371 8.489 0 15.371-6.882 15.371-15.371 0-8.488-6.882-15.37-15.371-15.37z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M121.096 279.093c-8.489 0-15.371 6.882-15.371 15.371 0 8.488 6.882 15.37 15.371 15.37 8.488 0 15.37-6.882 15.37-15.37 0-8.489-6.882-15.371-15.37-15.371z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M86.86 279.093c-8.488 0-15.37 6.882-15.37 15.371 0 8.488 6.882 15.37 15.37 15.37 8.49 0 15.371-6.882 15.371-15.37 0-8.489-6.881-15.371-15.37-15.371z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M139.253 372.71a8.198 8.198 0 100 16.396 8.198 8.198 0 000-16.396z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M105.008 372.71a8.198 8.198 0 100 16.396 8.198 8.198 0 000-16.396z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M122.12 343.282a8.197 8.197 0 00-8.197 8.198 8.197 8.197 0 008.197 8.197 8.197 8.197 0 100-16.395z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M87.885 343.282a8.198 8.198 0 100 16.395 8.198 8.198 0 000-16.395z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M138.402 438.108a4.1 4.1 0 100 8.199 4.1 4.1 0 000-8.199z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M105.008 432.605a8.197 8.197 0 100 16.395 8.197 8.197 0 000-16.395z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M122.12 403.175a8.197 8.197 0 00-8.197 8.198 8.197 8.197 0 008.197 8.197 8.197 8.197 0 100-16.395z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2664",
    d: "M87.885 403.175a8.198 8.198 0 100 16.395 8.198 8.198 0 000-16.395z"
  })));
}

export default __webpack_public_path__ + "bubbles-blue.colors.7a551ce8.svg";
export { SvgBubblesBluecolors as ReactComponent };